import React, { createContext, useContext, ReactNode } from "react";
import useNotice from "@root/hooks/useNotice";

const defaultState: allAnyTypes = {
  noticeLoading: false,
  addNoticeLoading: false,
  deleteNoticeLoading: false,
  updateNoticeLoading: false,
  noticeData: [],
  pageNo: 1,
  setPageNo: () => {},
  pageCount: 1,
  setPageCount: () => {},
  doUpdateNotice: () => {},
  removeNotice: () => {},
  fetchNotice: () => {},
  addNotice: () => {},
  publishNoticeData: [],
  publishNoticeLoading: false,
  fetchPublishNotice: () => {},
};

const NoticeContext = createContext<allAnyTypes>(defaultState);

interface NoticeProviderProps {
  children: ReactNode;
}

export const NoticeProvider: React.FC<NoticeProviderProps> = ({ children }) => {
  const Notice = useNotice();
  return (
    <NoticeContext.Provider value={Notice}>{children}</NoticeContext.Provider>
  );
};

export const useNoticeContext = () => {
  return useContext(NoticeContext);
};
